import React from "react";
import { useForm } from "react-hook-form";
import ButtonWrapper from "../../components/Button";
import FileUploader from "../../reusableComponents/FileUploader2";
import { useTranslation } from "react-i18next";
import { useEffect } from "react";
import { useSelector } from "react-redux";

const Step2 = ({ formData, handleTabChange }) => {
  const { documents } = useSelector((state) => state.formMT);
  const { t } = useTranslation();
  const defaultValues = {
    ...formData,
  };
  const { handleSubmit, control, watch, setValue, getValues, reset } = useForm({ defaultValues });
  const onSubmit = (data) => {
    handleTabChange(2, data);
  };
  useEffect(() => {
    setValue("documents", documents);
  }, [documents]);
  return (
    <section className="groupContainer">
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="formContainer">
          <div className="formHeaderContainer">
            <h2 className="formHeading">{"Documents Details"}</h2>
          </div>

          <div className="formInputContainer">
            <div className="columnWrapper">
              <FileUploader
                label={"Ownership Document"}
                control={control}
                name="applicantPhoto"
                validationMsg="(jpg, jpeg, png file only and Max file Size 10 MB)"
                required
                isMandatory
                tab={1}
              />
              <FileUploader
                isMandatory
                label={"Affidavit"}
                control={control}
                name="Affidavit"
                validationMsg="(pdf file only and Max file Size 30 MB)"
                required
              />
            </div>
            <div className="columnWrapper">
              <FileUploader
                isMandatory
                label={t("Owner Signature")}
                control={control}
                name="Owner Signature"
                validationMsg="(pdf file only and Max file Size 30 MB)"
                required
              />
            </div>
          </div>
        </div>

        <div className="footerContainer">
          <div className="buttonWrapper">
            <ButtonWrapper variant="contained" color="success" size="medium" label="Save" type="submit" sx={{ backgroundColor: "#157CB3" }} />
          </div>
        </div>
      </form>
    </section>
  );
};

export default Step2;
